import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

export const usePositionStatus = (key) => {
    const { positions, selectedPositions } = useSelector((state) => state[key]);
    const [positionStatuses, setPositionStatuses] = useState([]);

    useEffect(() => {
        setPositionStatuses([]);
        positions?.data.every((position) => {
            if (selectedPositions.indexOf(position.id) !== -1) {
                setPositionStatuses((prev) => {
                    if (prev.indexOf(position.status) === -1) {
                        return [...prev, position.status];
                    }
                    return prev;
                });
            }
            return true;
        });
    }, [positions, selectedPositions]);

    return [positionStatuses, selectedPositions];
};
